<script setup>
import { computed } from 'vue';

defineOptions({ name: 'OteraMark' });

const props = defineProps({
  size: { type: Number, default: 22 }
});

const style = computed(() => ({
  width: `${props.size}px`,
  height: `${props.size}px`,
  fontSize: `${props.size * 0.55}px`
}));
</script>

<template>
  <span
    class="tb__brand-mark"
    :style="style"
  >O</span>
</template>
